import React, { useEffect, useRef, useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import {
    getDatasetAtEvent,
    getElementAtEvent,
    getElementsAtEvent,
    Line,
} from 'react-chartjs-2'
import { format, subMonths } from 'date-fns'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

const LineChart = ({ dataChart, selectedFilter, showChart }) => {
    const chartRef = useRef()
    const [filteredData, setFilteredData] = useState([])
    const [filteredDates, setFilteredDates] = useState([])
    const [labelRangeDates, setLabelRangeDates] = useState("")
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                align: 'center',
                padding: {
                    top: 170,
                },
            },
            title: {
                display: true,
                text: `${labelRangeDates}`,
                align: 'start',
                padding: {
                    bottom: 20,
                    top: 40,
                },
            },
        },
    }

    const rangeDate = () => {
        // TODO: Calculate range from the passed data, we may want to keep the X months since that's the starting month, the custom range may also be passed
        if (dataChart.length > 0) {
            let dateFrom = new Date(dataChart[0].reportingMonth.replace('-','/'))
            let dateTo = new Date(dataChart[dataChart.length - 1].reportingMonth.replace('-','/'))
            return `${format(dateFrom, 'MMM yyyy')} - ${format(dateTo, 'MMM yyyy')}`
        }
    }

    useEffect(() => {
        setLabelRangeDates(rangeDate())
    }, [selectedFilter, dataChart])

    const data = {
        labels: filteredDates,
        datasets: [
            {
                label: 'Cumulative Imbalance',
                data: filteredData.length ? filteredData : [],
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    }

    const onClickElement = (event) => {
        let elementClicked = getElementAtEvent(chartRef.current, event)

        printElementAtEvent(getDatasetAtEvent(chartRef.current, event))
    }

    const printElementAtEvent = (element) => {
        if (!element.length) return

        const { datasetIndex, index } = element[0]
    }

    useEffect(() => {
        setFilteredData(
            dataChart
                .map((report) =>
                    report.cumulativeImbalance
                )
        )
        setFilteredDates(
            dataChart
                .map((report) => {
                    const date = new Date(report.reportingMonth.replace('-','/'))
                    return format(date, 'MMM yyyy')
                })
        )
    }, [dataChart, selectedFilter])

    const content = () => {
        if (showChart && dataChart.length >= 1) {
            return (
                <Line
                    ref={chartRef}
                    options={options}
                    data={data}
                    onClick={onClickElement}
                    height={300}
                />
            )
        } else if (showChart && dataChart.length === 0) {
            return (
                <p className="text-center p-4">
                    No statements match your search criteria.
                </p>
            )
        }
    }

    return <>{content()}</>
}

export default LineChart
